import { AgentLookupResponse } from '@breathelife/types';

import ApiService from './ApiService';

export async function getAdvisorByCode(agentCode: string): Promise<AgentLookupResponse> {
  const { data } = await ApiService.getAdvisorByCode(agentCode);

  return data;
}
